import { AnyFunc } from '@/global';
import { message, Modal } from 'antd';
import dayjs, { Dayjs } from 'dayjs';
import { transformLocationGcj02towgs84 } from './tencentMap';

// 格式日期到秒
export const formatDateToSecond = (time: any) => {
  let startTime: string | null = null;
  let endTime: string | null = null;
  if (time && time.length > 0) {
    const startMoment: Dayjs = time[0];
    if (startMoment) {
      startTime = startMoment.format('YYYY-MM-DD HH:mm:ss');
    }
    const endMoment: Dayjs = time[1];
    if (endMoment) {
      endTime = endMoment.format('YYYY-MM-DD HH:mm:ss');
    }
  }
  return {
    startTime: startTime,
    endTime: endTime,
  };
};
// 格式日期到日
export const formatDateToDate = (time: any) => {
  let startTime: string | null = null;
  let endTime: string | null = null;
  if (time && time.length > 0) {
    const startMoment: Dayjs = time[0];
    if (startMoment) {
      startTime = startMoment.format('YYYY-MM-DD');
    }
    const endMoment: Dayjs = time[1];
    if (endMoment) {
      endTime = endMoment.format('YYYY-MM-DD');
    }
  }
  return {
    startTime: startTime,
    endTime: endTime,
  };
};
// 初始日期到秒
export const createInitialDateToSecond = (
  searchStartTime: any,
  searchEndTime: any,
) => {
  if (searchStartTime && searchEndTime) {
    const startStime = dayjs(searchStartTime, 'YYYY-MM-DD HH:mm:ss');
    const endStime = dayjs(searchEndTime, 'YYYY-MM-DD HH:mm:ss');
    return [startStime, endStime];
  }
  return [];
};

// 初始时间到秒
export const createInitialTimeToSecond = (startTime: any, endTime: any) => {
  if (startTime && endTime) {
    const startStime = dayjs(startTime, 'HH:mm:ss');
    const endStime = dayjs(endTime, 'HH:mm:ss');
    return [startStime, endStime];
  }
  return [];
};

// 格式化时间到秒
export const formateTimeToSecond = (time: any[]) => {
  if (time && time.length > 0 && time[0] && time[1]) {
    return {
      startTime: time[0].format('HH:mm:ss'),
      endTime: time[1].format('HH:mm:ss'),
    };
  } else {
    return {
      startTime: null,
      endTime: null,
    };
  }
};

// 格式日期到秒
export const formatDateStringToSecond = (time: any) => {
  let date: any = new Date(time);
  let year: any = date.getFullYear();
  let month: any = date.getMonth() + 1;
  let day: any = date.getDate();
  let hours: any = date.getHours();
  let minutes: any = date.getMinutes();
  let seconds: any = date.getSeconds();

  month = month.toString().padStart(2, '0');
  day = day.toString().padStart(2, '0');
  hours = hours.toString().padStart(2, '0');
  minutes = minutes.toString().padStart(2, '0');
  seconds = seconds.toString().padStart(2, '0');

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};

/**
 * 获取权限按钮
 * @param sourceCode
 * @returns
 */
export const getPermissionBtn = (sourceCode: string) => {
  if (!sourceCode) {
    return false;
  }
  const win = window as any;
  const { buttonMap } = win.store.getState().commonReducer;
  if (buttonMap && buttonMap.has(sourceCode)) {
    return true;
  }
  return false;
};

export const checkPhone = (mobile: string) => {
  const phone = /^((1[0-9]{1})+\d{9})$/;
  return phone.test(mobile);
};

/**
 * 判断字符串是否全部为中文字符（基本汉字及扩展区）
 * @param str 要判断的字符串
 */
export const isChinese = (str: string) => {
  if (!str || typeof str !== 'string') return false;
  // 包含常用中日韩统一表意文字区及扩展区（简单判断，不覆盖所有罕用扩展）
  return /^[\u4E00-\u9FFF\u3400-\u4DBF\uF900-\uFAFF]+$/.test(str.trim());
};

/**
 * 判断字符串是否全部为英文字母（A-Z, a-z）
 * @param str 要判断的字符串
 */
export const isEnglish = (str: string) => {
  if (!str || typeof str !== 'string') return false;
  return /^[A-Za-z]+$/.test(str.trim());
};

export const isNullObject = (obj: any) => {
  if (!obj) {
    return true;
  }
  return Object.keys(obj).length === 0;
};

export const isEmpty = (param: any) => {
  if (Array.isArray(param) || typeof param === 'string') {
    return param.length === 0;
  }
  return true;
};

/**
 * 格式化数字展示（如果是百分比数据可以加上百分比的符号）
 * - number 且为 0 时返回 '0'
 * - 其他 number 返回 toFixed(digits)
 * - 非 number 返回 '-'
 */
export const formatNumber = (
  value: any,
  digits: number,
  appendPercent: boolean = false,
) => {
  // 是否需要加上百分比
  const make = (str: string) => (appendPercent ? `${str}%` : str);

  // 如果已经是number，直接处理
  if (typeof value === 'number') {
    if (value === 0) return make('0');
    if (!Number.isFinite(value)) return '-';
    return make(value.toFixed(digits));
  }

  // 如果是string，尝试转换为number
  if (typeof value === 'string') {
    const parsed = Number(value);
    // 转换失败或为非有限数，返回原始字符串
    if (!Number.isFinite(parsed)) return value;
    if (parsed === 0) return make('0');
    return make(parsed.toFixed(digits));
  }

  // 其他类型返回默认占位
  return '-';
};

const decodeUriQuery = (value: any) => {
  let decoded: string | null = null;
  try {
    decoded = decodeURIComponent(value);
  } catch (e) {
    decoded = value;
  }
  return decoded;
};

const encodeUriQuery = (value: any) => {
  let encoded: string | null = null;
  try {
    encoded = encodeURIComponent(value);
  } catch (e) {
    encoded = value;
  }
  return encoded;
};

export const makeUrlQuery = (searchQuery: any) => {
  const paramsInQuery = Object.entries(searchQuery || {})
    .map((item: any) => {
      const [k, v] = item;
      return `${k}=${encodeUriQuery(v)}`;
    })
    .join('&');
  return paramsInQuery;
};

export const formatLocation = (locationSearch: string) => {
  let search = '';
  if (locationSearch.indexOf('?') != -1) {
    search = locationSearch.split('?')[1];
  } else {
    search = locationSearch;
  }
  const params = search.split('&');
  const objParams: any = {};
  params.forEach((item) => {
    const paramItem = item.split('=');
    objParams[paramItem[0]] = decodeUriQuery(paramItem[1]);
  });
  return objParams;
};

export const debounce = (fn: Function, time: number) => {
  let timer: any = null;
  return function (...args: any[]) {
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(() => {
      fn.apply(null, args);
    }, time);
  };
};
export function debounceWithImmediate<T extends (...args: any[]) => any>(
  func: T,
  wait: number,
  immediate?: boolean,
) {
  immediate = immediate === undefined ? true : immediate;
  let timeout: any, result: any;

  const debounced = function (this: ThisParameterType<T>) {
    const context = this;
    const args = arguments;

    if (timeout) clearTimeout(timeout);
    if (immediate) {
      const callNow = !timeout;
      timeout = setTimeout(function () {
        timeout = null;
      }, wait);
      if (callNow)
        result = func.apply(context, Array.prototype.slice.call(args));
    } else {
      timeout = setTimeout(function () {
        func.apply(context, Array.prototype.slice.call(args));
      }, wait);
    }
    return result;
  };

  (debounced as any).cancel = function () {
    clearTimeout(timeout);
    timeout = null;
  };

  return debounced as ((...args: Parameters<T>) => ReturnType<T>) & {
    cancel: () => void;
  };
}

export const formatOptions = (
  list: any[],
  { labelKey = 'name', valueKey = 'code' }: any = {},
) => {
  return Array.isArray(list) && list.length > 0
    ? list.map((item: any) => ({
        label: item[labelKey],
        value: item[valueKey],
      }))
    : [];
};

/**
 * 数组去重
 * @param arr 接收的原数组
 * @param key 如果是对象数组[{id: 1}, {id: 2}, {id: 3}]，则需要以什么key作为重复的标准，普通数组[1,2,3,2]不需要
 * @returns
 */

export const arrUnique = (arr: [], key?: string) => {
  let returnArr = [];
  if (key) {
    // 对象数组去重
    const obj = {};
    returnArr = arr.reduce((cur, next) => {
      obj[next[key]] ? '' : ((obj[next[key]] as any) = true && cur.push(next));
      return cur;
    }, []);
    return returnArr;
  }
  // 普通数组去重
  returnArr = arr.reduce((cur, next) => {
    !cur.includes(next) && cur.push(next);
    return cur;
  }, []);
  return returnArr;
};

// 货箱格口配置规则校验
const validationCaseData = (
  boxColumnNum: number,
  colHeigh: any,
  minHeight: any,
  gridsArr: any[],
  key: string,
) => {
  let tempHeight = 0;
  let colIdx = 0;
  const valid = {
    isValid: true,
    msg: '',
  };
  gridsArr.map((item: any, idx: number) => {
    const grid = Object.assign({}, item);
    if (colIdx == boxColumnNum) {
      valid.isValid = false;
      valid.msg = `生成失败，格口配置有误，无法生成${key}的列数【${boxColumnNum}】`;
      return;
    } else if (parseInt(grid.height) > colHeigh) {
      valid.isValid = false;
      valid.msg = `生成失败，【${key}】格口号【${grid.gridNo}】的高度大于货箱高度【${colHeigh}】mm`;
      return;
    }
    tempHeight += parseInt(grid.height);
    // 判断是否是最后一个格子:a.根据下标判断 b.累计格子高度+下一个格子高度大于最小列高的1/3,下一个格子是下一列的
    if (gridsArr.length === idx + 1) {
      grid.isLast = true;
    } else {
      const lastGrid = gridsArr[idx + 1];
      const nextSumHeight = tempHeight + parseInt(lastGrid.height);
      if (nextSumHeight - colHeigh > minHeight / 3) {
        grid.isLast = true;
      }
    }

    if (grid.isLast && gridsArr.length > idx + 1) {
      colIdx++;
      tempHeight = 0;
    }
  });
  return valid;
};
export const validationGrid = (
  editGridList: any[],
  gridPositionValue: any,
  gridCofigArr: any,
) => {
  let valid = {
    isValid: true,
    msg: '',
  };
  // 每一侧的列数
  const leftColumnNum = gridPositionValue.leftBoxColumnNum || 0;
  const rightColumnNum = gridPositionValue.rightBoxColumnNum || 0;
  // 每一侧的格口总高度
  let leftColSumHeight = 0;
  let rightColSumHeight = 0;

  let isValidatSize = true;
  let leftGridNum = 0;
  let rightGridNum = 0;
  const leftGrids: any[] = [];
  const rightGrids: any[] = [];
  let minLeftHeight = 0;
  let minRightHeight = 0;
  editGridList.map((grid: any) => {
    if (grid.side === '左侧') {
      leftGridNum++;
      leftColSumHeight += parseInt(grid.height);
      leftGrids.push(grid);
      if (parseInt(grid.height) < minLeftHeight || minLeftHeight == 0) {
        minLeftHeight = parseInt(grid.height);
      }
    }
    if (grid.side === '右侧') {
      rightGridNum++;
      rightColSumHeight += parseInt(grid.height);
      rightGrids.push(grid);
      if (parseInt(grid.height) < minRightHeight || minRightHeight == 0) {
        minRightHeight = parseInt(grid.height);
      }
    }
    if (
      gridCofigArr.findIndex((size: any) => size.sizeStr === grid.sizeStr) ===
        -1 &&
      isValidatSize
    ) {
      // 判断是否出现当前数据规格跟配置的不一致的情况
      isValidatSize = false;
    }
  });

  if (leftGridNum < leftColumnNum) {
    valid.isValid = false;
    valid.msg = '生成失败，左侧格口数不足！';
  } else if (rightGridNum < rightColumnNum) {
    valid.isValid = false;
    valid.msg = '生成失败，右侧格口数不足！';
  } else if (leftGridNum == 0 && rightGridNum == 0) {
    valid.isValid = false;
    valid.msg = '操作失败，请维护详细格口信息！';
  } else if (leftGridNum && leftColumnNum == 0) {
    valid.isValid = false;
    valid.msg = '生成失败，左侧按照实际显示列数为0，不应该存在格口数据！';
  } else if (rightGridNum && rightColumnNum == 0) {
    valid.isValid = false;
    valid.msg = '生成失败，右侧按照实际显示列数为0，不应该存在格口数据！';
  } else if (!isValidatSize) {
    valid.isValid = false;
    valid.msg = '生成失败，格口规格参数不一致，请检查！';
  } else {
    // 每一侧的列高度
    let leftColHeigh: any = 0;
    let rightColHeigh: any = 0;
    if (leftColumnNum) {
      leftColHeigh = (leftColSumHeight / leftColumnNum).toFixed(2);
    }
    if (rightGridNum) {
      rightColHeigh = (rightColSumHeight / rightColumnNum).toFixed(2);
    }
    const leftValidData = validationCaseData(
      leftColumnNum,
      leftColHeigh,
      minLeftHeight,
      leftGrids,
      '左侧',
    );
    const rightValidData = validationCaseData(
      rightColumnNum,
      rightColHeigh,
      minRightHeight,
      rightGrids,
      '右侧',
    );
    if (!leftValidData.isValid) {
      valid = leftValidData;
    } else if (!rightValidData.isValid) {
      valid = rightValidData;
    }
  }
  return valid;
};

export async function parseResponseBody(val: any, contentType?: string | null) {
  const ct = contentType ? String(contentType) : '';
  if (ct.indexOf('application/x-www-form-urlencoded') >= 0) {
    const resp = val as Response;
    const txt = await resp.text();
    return txt;
  } else if (ct.indexOf('application/json') >= 0) {
    const resp = val as Response;
    const json = await resp.json();
    return json;
  } else if (ct.indexOf('text/plain') >= 0) {
    const resp = val as Response;
    const txt = await resp.text();
    return txt;
  } else {
    return val ? String(val) : '';
  }
}

export const showMsg = ({
  msg,
  type,
  duration,
  onClose,
}: {
  msg: string;
  type: 'success' | 'error' | 'info' | 'warning' | 'loading';
  duration?: number;
  onClose?: AnyFunc;
}) => {
  switch (type) {
    case 'success':
      message.success(msg, duration, onClose);
      break;
    case 'error':
      message.error(msg, duration, onClose);
      break;
    case 'info':
      message.info(msg, duration, onClose);
      break;
    case 'warning':
      message.success(msg, duration, onClose);
      break;
    case 'loading':
      message.success(msg, duration, onClose);
      break;
  }
};

export const formatTypeList = (resourceList: any[], type: string) => {
  if (!Array.isArray(resourceList)) return [];

  // 先过滤出类型为 type 的项目
  const tabItems = resourceList.filter((item) => item.type === type);

  // 根据 path 属性进行分组
  const groupedByPath: Record<string, any[]> = {};

  tabItems.forEach((item) => {
    const path = item.path || 'undefined';
    if (!groupedByPath[path]) {
      groupedByPath[path] = [];
    }
    groupedByPath[path].push(item);
  });

  // 对每个分组内的项目按照 orderBy 属性进行排序
  for (const path in groupedByPath) {
    groupedByPath[path].sort((a, b) => {
      // 如果 orderBy 不存在，则默认为 0
      const orderA = a.orderBy !== undefined ? a.orderBy : 0;
      const orderB = b.orderBy !== undefined ? b.orderBy : 0;
      return orderA - orderB; // 升序排列
    });
  }

  // 返回格式化后的结果
  return groupedByPath;
};

export const isNumber = (value: any) => {
  return typeof value === 'number' && !isNaN(value);
};

export function formatISODateToYYYYMMDD(isoDateString) {
  const date = new Date(isoDateString);

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从 0 开始，所以加 1，并确保两位数
  const day = String(date.getDate()).padStart(2, '0'); // 确保两位数

  return `${year}-${month}-${day}`;
}

// 手动上报点击事件
export const customReport = (clstag: any) => {
  try {
    (window as any).__qd__ &&
      (window as any).__qd__.click({
        cls: clstag,
      });
  } catch (e) {
    console.log(e);
  }
};

/**
 * 解码差分压缩坐标数组（腾讯地图返回的）
 * - `coords` 为一维数字数组，形如 [lat0, lon0, dlat1, dlon1, dlat2, dlon2, ...]
 * - 从索引 2 开始的每个值是相对于前两个位置的增量（按 1e6 缩放）
 * - 解码算法：coords[i] = coords[i - 2] + coords[i] / 1e6
 * @param {any[]} coords
 * @return {*}
 */
export const decompressLocation = (coords: unknown) => {
  const result: any = [];
  if (!Array.isArray(coords)) return result;
  for (let i = 2; i < coords.length; i++) {
    coords[i] = coords[i - 2] + coords[i] / 1000000;
  }
  for (let i = 0; i < coords.length; i += 2) {
    result.push({
      lat: coords[i],
      lon: coords[i + 1],
    });
  }
  return result;
};

/**
 * 将一组 GCJ-02 坐标转换为 WGS84（EPSG:4326）坐标
 * @param coords 输入坐标数组，格式 [[lon, lat], ...]
 * @returns 转换后的坐标数组，格式 [[lon, lat], ...]
 */
export const convertGcj02ArrayToWgs84 = (coords: number[][]): number[][] => {
  if (!Array.isArray(coords)) return [];
  return coords.map((p) => {
    const lon = Number(p[0]);
    const lat = Number(p[1]);
    const conv = transformLocationGcj02towgs84({ lon, lat });
    if (!conv) {
      return [lon, lat];
    }
    return [Number(conv.lon), Number(conv.lat)];
  });
};

export const checkIsPermission = (key: string, resourceList: any[]) => {
  const store = (window as any).store;
  if (!store) {
    return false;
  }
  if (resourceList && resourceList.length > 0) {
    const keyInfo = resourceList.filter((v) => v.code === key);
    if (keyInfo.length > 0) {
      return true;
    }
  }
  return false;
};

export const transferDateStringToDayJs = (time: string) => {
  return time ? dayjs(time) : null;
};

export const isOutliers = (value: any) => {
  return (
    value === null ||
    value === undefined ||
    (typeof value === 'number' && isNaN(value))
  );
};

export const getSearchTermFromButtonList = (buttonList: any) => {
  if (!Array.isArray(buttonList)) {
    return [];
  }
  return buttonList
    .filter(
      (item) =>
        item &&
        item.code &&
        typeof item.code === 'string' &&
        item.code.startsWith('SearchTerm_'),
    )
    .map((item) => ({
      fieldName: item.code.replace('SearchTerm_', ''),
      name: item.name,
    }));
};

/**
 * 根据id字段求两个数组的交集
 * @param arr1 第一个数组
 * @param arr2 第二个数组
 * @param idKey1 数组1的id字段名，默认为'id'
 * @param idKey2 数组2的id字段名，如果不传则使用idKey1的值
 * @returns 交集数组，返回arr1中存在于arr2的元素
 */
export const getArrayIntersectionById = (
  arr1: any[],
  arr2: any[],
  idKey1: string = 'id',
  idKey2?: string,
) => {
  if (!Array.isArray(arr1) || !Array.isArray(arr2)) {
    return [];
  }
  const key2 = idKey2 || idKey1;
  const arr2IdSet = new Set(arr2.map((item) => item?.[key2]));
  return arr1.filter((item) => item?.[idKey1] && arr2IdSet.has(item[idKey1]));
};

export const downloadUrl = (url: any) => {
  if (!url) return;
  const newUrl = url?.startsWith('http:')
    ? url?.replace('http:', 'https:')
    : url;
  window.open(newUrl, '_self');
};

export const confirmResetData = (cb: any) => {
  Modal.confirm({
    title: '确定要重置数据吗？',
    content: '确定后，表单将恢复成原始数据，请谨慎操作！',
    width: 500,
    onOk: (close) => {
      cb();
      close();
    },
  });
};

/**
 * 判断数组和对象的数据是否为空
 * @param value 需要检查的值
 * @returns 如果是数组则判断长度是否为0，如果是对象则判断是否有属性，其他类型一律返回true
 */
export const isDataEmpty = (value: any) => {
  if (Array.isArray(value)) {
    return value.length === 0;
  }
  if (value && typeof value === 'object' && value.constructor === Object) {
    return Object.keys(value).length === 0;
  }
  return true;
};

// 将day级别的日期字符串改为month级别的日期字符串
// 如：2025-09-09 转换为 2025-09
export const formatDateToYearMonth = (dateStr: string) => {
  if (!dateStr || typeof dateStr !== 'string') return '';
  const parts = dateStr.split('-');
  if (parts.length >= 2) {
    return `${parts[0]}-${parts[1]}`;
  }
  return dateStr;
};

export const transferHttpUrlToHttpsUrl = (url: any) => {
  if (typeof url === 'string') {
    return url.replace('http://', 'https://');
  }
  return null;
};

/**
 * 角度转化为弧度
 * @param {number} deg
 * @return {*}  {number}
 */
export const degToRad = (deg: number): number => (deg * Math.PI) / 180;

/**
 * 弧度转化为角度
 * @param {number} rad
 * @return {*}  {number}
 */
export const radToDeg = (rad: number): number => (rad * 180) / Math.PI;

/**
 * 格式化数字列表，将输入的列表中的每个元素转换为数字，如果无法转换则过滤掉
 *
 * @param {unknown} numList
 * @return {*}
 */
export const formatNumberList = (numList: unknown): number[] => {
  if (!Array.isArray(numList)) return [];
  return numList.map((num) => Number(num)).filter((num) => !isNaN(num));
};

/**
 * 将值适配为数组
 *
 * @param {*} value
 * @return {*}  {any[]}
 */
export const adaptToArray = (value: any): any[] => {
  if (Array.isArray(value)) {
    return value;
  }
  if (value === null || value === undefined || Number.isNaN(value)) {
    return [];
  }
  return [value];
};

/**
 * 过滤字符串前后的不可见字符（包括空格、tab、换行、零宽字符、BOM、不间断空格、全角空格等）
 * @param value 需要过滤的值
 * @returns 如果是字符串则返回过滤后的字符串；否则返回原值
 */
export const trimInvisibleChars = <T>(value: T): T => {
  if (typeof value !== 'string') {
    return value;
  }
  return (value as unknown as string).replace(
    /^[\s\u00A0\u200B-\u200F\uFEFF\u3000]+|[\s\u00A0\u200B-\u200F\uFEFF\u3000]+$/g,
    ''
  ) as unknown as T;
};

/**
 * 判断字符串是否包含特殊字符
 * 当前特殊字符范围：! @ # $ % ^ & *、空白字符（空格/换行/Tab 等）和 emoji
 * @param str 需要判断的字符串
 * @returns 是否包含特殊字符
 */
export const hasSpecialChars = (str: string): boolean => {
  if (!str || typeof str !== 'string') return false;

  const blockedCharsPattern = /[!@#$%^&*\s]/;
  const emojiPattern = /\p{Extended_Pictographic}|\p{Emoji_Presentation}/u;

  return blockedCharsPattern.test(str) || emojiPattern.test(str);
};
